var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { convertVideoElementConfig, createConfig } from './base/config-helper';
import ReferenceReport from './base/reference-report';
import { AUDIO_EFFECT_NAME, closeAudioSourceNode } from './base/videonode/audio/audio-helper';
import { CDN_PATH_PREFIX, END_STATE, KERNEL_NAME, PLAY_EVENT, PLAYER_LOG_LEVEL, PRELOAD_TYPE, SET_LEVEL_MODE, VIDEO_CONTAINER_CLASS, VIDEO_STATE, } from './enums';
import { i18nConfig } from './i18n';
import { AUDIO_TRACK_ERROR_MSG, } from './interfaces';
import KernelFactory, { getKernelCdnPath } from './kernel-selector/kernel-factory';
import AutoPlayPolicy from './libs/autoplay-policy';
import EvtEmitter from './libs/event-emitter';
import SimpleDefer from './libs/simple-defer';
import { Logger } from './log';
import { enableConsoleOutput } from './log/console';
import { domTool, logMethodCallDecoratorCreator, performanceCostDecoratorCreator, t, videoTool, } from './util';
var logMethodCall = logMethodCallDecoratorCreator('KernelProxy');
var performanceCost = performanceCostDecoratorCreator('KernelProxy');
/** 全局的内核加载map，用于记录内核的js加载。加载初记录到map中，加载完成后resolve */
var loadKernelDeferMap = {};
/** player.dataset[KEY] 的 key，用于判断是否重复创建了播放器 */
var CONTAINER_DATASET_KEY = 'tp';
/**
 * 代理播放内核，在内部实现播放内核的创建、切换、销毁，事件转发等。这里已经创建了一组video标签，然后通过config传给正在使用的播放内核。而且播放
 * 内核之间切换，video标签是复用的。
 */
var KernelProxy = /** @class */ (function (_super) {
    __extends(KernelProxy, _super);
    function KernelProxy(conf) {
        var _this = _super.call(this) || this;
        /** 音量值，用于没有创建内核也允许设置的临时保存*/
        _this.volumeInner = 1;
        _this.videoElementsInner = [];
        _this.addedEvts = [];
        _this.isDestroyed = false;
        _this.playerConfig = createConfig(conf);
        _this.logger = new Logger(_this.playerConfig.instanceId, 'KernelProxy');
        if (conf.logLevel > PLAYER_LOG_LEVEL.NONE) {
            // 不传入参数时启用所有控制台输出
            enableConsoleOutput();
        }
        if (!_this.playerConfig.videoElements) {
            _this.playerConfig.videoElements = _this.createVideoElements();
        }
        _this.setPlayerContainer();
        _this.createVideoElementsContainer();
        _this.kernelEvtFuncs = _this.kernelEvtHandler.bind(_this);
        // 引用上报
        if (!_this.playerConfig.isPrivateDeployment) {
            ReferenceReport.getReporter().rptRate = _this.playerConfig.rptRate;
            ReferenceReport.getReporter().collectUsage();
        }
        return _this;
    }
    Object.defineProperty(KernelProxy.prototype, "container", {
        get: function () {
            return this.containerEl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "config", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.config) || this.playerConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "useWorker", {
        get: function () {
            var _a;
            return !!((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.useWorker);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "kernelName", {
        get: function () {
            var _a;
            return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.kernelName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "videoElements", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.videoElements) || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "currentVideoElement", {
        get: function () {
            var _a;
            return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.currentVideoElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "supportPreload", {
        get: function () {
            var _a;
            return !!((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.supportPreload);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "duration", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.duration) || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "playtime", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.playtime) || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "videoInfos", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.videoInfos) || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "preloadVideoInfos", {
        get: function () {
            var _a;
            return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.preloadVideoInfos;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "currentVideoInfo", {
        get: function () {
            var _a;
            return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.currentVideoInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "currentVideoInfoIdx", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.currentVideoInfoIdx) || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "totalVideoInfoCount", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.totalVideoInfoCount) || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "supportPlaybackRate", {
        get: function () {
            var _a;
            return !!((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.supportPlaybackRate);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "played", {
        get: function () {
            var _a;
            return !!((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.played);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "state", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.state) || VIDEO_STATE.IDLE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "videoSize", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.videoSize) || { width: 0, height: 0 };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "videoBuffered", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.videoBuffered) || [];
        },
        enumerable: false,
        configurable: true
    });
    KernelProxy.prototype.captureVideo = function (dx, dy, dw, dh, extra) {
        var _a;
        return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.captureVideo(dx, dy, dw, dh, extra);
    };
    KernelProxy.prototype.log = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log.apply(_a, args);
    };
    KernelProxy.prototype.warn = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.warn.apply(_a, args);
    };
    KernelProxy.prototype.error = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.error.apply(_a, args);
    };
    KernelProxy.prototype.hasAppended = function (value) {
        var _a;
        return !!((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.hasAppended(value));
    };
    KernelProxy.prototype.hasPreloaded = function (value) {
        var _a;
        return !!((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.hasPreloaded(value));
    };
    Object.defineProperty(KernelProxy.prototype, "volume", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.volume) || this.volumeInner;
        },
        set: function (value) {
            this.volumeInner = value;
            if (this.kernel) {
                this.kernel.volume = value;
            }
            else {
                // load前设置音量补充发出事件，但没有videoInfo
                this.emit(PLAY_EVENT.VOLUME_CHANGE, { volume: value });
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "volumeGain", {
        get: function () {
            if (this.kernel) {
                return this.kernel.volumeGain;
            }
            return 0;
        },
        set: function (gain) {
            if (this.kernel) {
                this.kernel.volumeGain = gain;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "audioEffect", {
        get: function () {
            if (this.kernel) {
                return this.kernel.audioEffect;
            }
            return AUDIO_EFFECT_NAME.DEFAULT;
        },
        set: function (effectName) {
            if (this.kernel) {
                this.kernel.audioEffect = effectName;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "playbackRate", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.playbackRate) || this.playbackRateInner;
        },
        set: function (value) {
            this.playbackRateInner = value;
            if (this.kernel) {
                this.kernel.playbackRate = value;
            }
            else {
                // load前设置倍速补充发出事件，但没有videoInfo
                this.emit(PLAY_EVENT.RATE_CHANGE, { playbackRate: value });
            }
        },
        enumerable: false,
        configurable: true
    });
    KernelProxy.prototype.resizeVideoElements = function (value) {
        var _a;
        (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.resizeVideoElements(value);
    };
    KernelProxy.prototype.resize = function (value) {
        var _a;
        (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.resize(value);
    };
    KernelProxy.prototype.seek = function (time) {
        var _a;
        return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.seek(time);
    };
    KernelProxy.prototype.play = function (urlConfig, extra) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.logger.log('play(urlConfig, ', extra, ')');
                        return [4 /*yield*/, this.checkConfigBeforeLoad(urlConfig, extra)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.play(urlConfig, extra)];
                }
            });
        });
    };
    KernelProxy.prototype.load = function (urlConfig, extra) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.checkConfigBeforeLoad(urlConfig, extra)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.load(urlConfig, extra)];
                }
            });
        });
    };
    KernelProxy.prototype.playNext = function (opts) {
        var _a;
        (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.playNext(opts);
    };
    KernelProxy.prototype.pause = function (pauseType) {
        var _a;
        (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.pause(pauseType);
    };
    KernelProxy.prototype.stop = function (endState) {
        var _a;
        (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.stop(endState);
    };
    KernelProxy.prototype.appendNext = function (value) {
        var _a;
        return !!((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.appendNext(value));
    };
    KernelProxy.prototype.preloadNext = function () {
        var _a;
        var confs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            confs[_i] = arguments[_i];
        }
        return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.preloadNext.apply(_a, confs);
    };
    KernelProxy.prototype.clearAllPreload = function () {
        var _a;
        (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.clearAllPreload();
    };
    KernelProxy.prototype.triggerAutoplay = function () {
        var _this = this;
        var _a;
        if (!this.kernel) {
            this.logger.log('triggerAutoplay(), start');
            var func = function (el) {
                var autoplay = new AutoPlayPolicy(el, { instanceId: _this.playerConfig.instanceId });
                return autoplay.userTrigger();
            };
            var triggerPromises = this.videoElementsInner.map(func);
            return Promise.all(triggerPromises);
        }
        return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.triggerAutoplay();
    };
    KernelProxy.prototype.setAudioTrack = function (id) {
        if (!this.kernel) {
            return Promise.reject(new Error(AUDIO_TRACK_ERROR_MSG.KERNEL_NOT_EXISTS));
        }
        return this.kernel.setAudioTrack(id);
    };
    KernelProxy.prototype.getAudioTrackList = function () {
        if (!this.currentVideoInfo)
            return [];
        return this.currentVideoInfo.audioTracks;
    };
    KernelProxy.prototype.getCurrentAudioTrack = function () {
        if (!this.currentVideoInfo)
            return NaN;
        return this.currentVideoInfo.currentAudioTrack;
    };
    KernelProxy.prototype.setLevel = function (urlOrUrlConfig, backupUrls, extraConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var nextLevelUrlConfig, preVideoInfo, _a, isKernelSwitched, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.kernel) {
                            return [2 /*return*/, Promise.reject(t(i18nConfig.core.ERROR_KERNEL_NOT_FOUND))];
                        }
                        nextLevelUrlConfig = typeof urlOrUrlConfig === 'string'
                            // 这里要拼接extra，带上drm参数
                            ? __assign(__assign({}, extraConfig), { url: urlOrUrlConfig }) : urlOrUrlConfig;
                        preVideoInfo = this.currentVideoInfo;
                        return [4 /*yield*/, this.checkWhetherNeedToSwitchKernel(nextLevelUrlConfig, null, false)];
                    case 1:
                        _a = _b.sent(), isKernelSwitched = _a.isKernelSwitched, error = _a.error;
                        if (error === null || error === void 0 ? void 0 : error.message) {
                            return [2 /*return*/, Promise.reject(error === null || error === void 0 ? void 0 : error.message)];
                        }
                        if (isKernelSwitched) {
                            return [2 /*return*/, this.setLevelWhenKernelSwitched(__assign(__assign(__assign({}, nextLevelUrlConfig), { backupUrls: backupUrls }), extraConfig), preVideoInfo)];
                        }
                        // 直接在老的内核上切换清晰度
                        if (typeof urlOrUrlConfig === 'string') {
                            return [2 /*return*/, this.kernel.setLevel(urlOrUrlConfig, backupUrls, extraConfig)];
                        }
                        return [2 /*return*/, this.kernel.setLevel(urlOrUrlConfig)];
                }
            });
        });
    };
    KernelProxy.prototype.on = function (type, listener, priority) {
        _super.prototype.on.call(this, type, listener, priority);
        this.proxyEvent(type);
        return this;
    };
    KernelProxy.prototype.once = function (type, listener, priority) {
        _super.prototype.once.call(this, type, listener, priority);
        this.proxyEvent(type, true);
        return this;
    };
    /**
     * 销毁当前proxy
     */
    KernelProxy.prototype.destroy = function () {
        var _a;
        this.unsetPlayerContainer();
        if (this.videoElementsInner) {
            this.videoElementsInner.forEach(function (videoElement) {
                closeAudioSourceNode(videoElement);
                videoTool.destroyElement(videoElement);
            });
            this.videoElementsInner = null;
        }
        if ((_a = this.videoElementsContainer) === null || _a === void 0 ? void 0 : _a.parentNode) {
            this.videoElementsContainer.remove();
        }
        this.destroyKernel();
        this.removeAllListeners();
        this.kernelEvtFuncs = null;
        this.playerConfig = null;
        this.isDestroyed = true;
    };
    /**
     * 检查是否需要切换内核。如果需要，则会销毁旧的内核，并创建新的内核。
     * @param urlConfig 传入的播放地址
     * @param emitStopEvent 是否需要派发Stop事件
     * @returns 是否有切换内核，如果没有旧的内核而创建了新的内核，也算切换。
     */
    KernelProxy.prototype.checkWhetherNeedToSwitchKernel = function (urlConfig, extra, emitStopEvent) {
        if (emitStopEvent === void 0) { emitStopEvent = true; }
        return __awaiter(this, void 0, void 0, function () {
            var checkUrlConfig, forceKernelName, selectedKernelName, kernelName;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.log('check switch kernel');
                        checkUrlConfig = (urlConfig instanceof Array) ? urlConfig[0] : urlConfig;
                        forceKernelName = (extra === null || extra === void 0 ? void 0 : extra.kernelName) || checkUrlConfig.kernelName;
                        selectedKernelName = KernelFactory.selectKernel(urlConfig, forceKernelName, this.playerConfig.kernelPriority);
                        // KernelFactory.selectKernel返回类型是IVideoERROR，意味着强制内核是无法播放当前视频，直接提示错误
                        if (typeof selectedKernelName !== 'string') {
                            return [2 /*return*/, {
                                    isKernelSwitched: false,
                                    error: selectedKernelName,
                                }];
                        }
                        this.logger.log('kernel select:', selectedKernelName);
                        if (!(selectedKernelName && !KernelFactory.kernelMap[selectedKernelName])) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadKernel(selectedKernelName)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        kernelName = KernelFactory.kernelMap[selectedKernelName] ? selectedKernelName : KERNEL_NAME.ORIGIN;
                        // 1.如果kernelName不一样，需要先销毁旧的
                        if (this.kernel && this.kernel.kernelName !== kernelName) {
                            // 如果已经触发播放（播放中），KernelProxy层需要补发STOPED事件出去，因为销毁当前内核的操作外部无法感知
                            if (this.kernel.played && emitStopEvent) {
                                this.emit(PLAY_EVENT.STOPED, {
                                    videoInfo: this.kernel.currentVideoInfo,
                                    endState: END_STATE.INTERRUPT,
                                });
                            }
                            this.destroyKernel();
                        }
                        if (!!this.kernel) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.createKernel(kernelName)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, {
                                isKernelSwitched: true,
                            }];
                    case 4: return [2 /*return*/, {
                            isKernelSwitched: false,
                        }];
                }
            });
        });
    };
    /**
     * 尝试从远程加载内核文件。加载成功后会自动注册到window.ThumbplayerCore.KernelFactory
     * @param kernelName 内核名称
     * @param retryTimes 失败时重试次数
     * @returns 是否成功加载
     */
    KernelProxy.prototype.loadKernel = function (kernelName, retryTimes) {
        if (retryTimes === void 0) { retryTimes = 3; }
        return __awaiter(this, void 0, void 0, function () {
            var kernelCdnPath, loadSucc_1, loadSucc, loadOption, i, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // 私有部署时不自动下载内核
                        if (this.config.isPrivateDeployment) {
                            return [2 /*return*/, false];
                        }
                        kernelCdnPath = getKernelCdnPath(kernelName, this.playerConfig.autoLoadKernelVerMap);
                        if (!kernelCdnPath) {
                            return [2 /*return*/, false];
                        }
                        if (!loadKernelDeferMap[kernelName]) return [3 /*break*/, 2];
                        this.logger.log("auto download kernel [".concat(kernelCdnPath, "] has been started!"));
                        return [4 /*yield*/, loadKernelDeferMap[kernelName].promise];
                    case 1:
                        loadSucc_1 = _a.sent();
                        this.logger.log("auto download kernel [".concat(kernelCdnPath, "] succ=").concat(loadSucc_1));
                        return [2 /*return*/, loadSucc_1];
                    case 2:
                        loadKernelDeferMap[kernelName] = new SimpleDefer();
                        this.logger.log("auto download kernel [".concat(kernelCdnPath, "]"));
                        loadSucc = false;
                        loadOption = {};
                        if (this.playerConfig.crossOriginForScript) {
                            loadOption.crossOrigin = this.playerConfig.crossOriginForScript;
                        }
                        i = 0;
                        _a.label = 3;
                    case 3:
                        if (!(i < retryTimes)) return [3 /*break*/, 9];
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, domTool.loadScript("".concat(CDN_PATH_PREFIX + kernelCdnPath, "?max_age=86400"), null, 10000, loadOption)];
                    case 5:
                        _a.sent();
                        if (this.isDestroyed) {
                            return [2 /*return*/, new Promise(function () { })];
                        }
                        this.logger.log("auto download kernel [".concat(kernelCdnPath, "] succ=true"));
                        loadSucc = true;
                        return [3 /*break*/, 7];
                    case 6:
                        err_1 = _a.sent();
                        loadSucc = false;
                        // 理论上加载失败也会走原生内核尝试播放，所以这里设计成不需要抛出异常，仅返回加载失败。
                        this.logger.error("auto download kernel [".concat(kernelCdnPath, "] failed"));
                        return [3 /*break*/, 7];
                    case 7:
                        if (loadSucc) {
                            return [3 /*break*/, 9];
                        }
                        _a.label = 8;
                    case 8:
                        i++;
                        return [3 /*break*/, 3];
                    case 9:
                        loadKernelDeferMap[kernelName].resolve(loadSucc);
                        return [2 /*return*/, loadSucc];
                }
            });
        });
    };
    /**
     * 创建内核实例。
     */
    KernelProxy.prototype.createKernel = function (kernelName) {
        this.kernel = KernelFactory.createKernel(kernelName, this.playerConfig);
        if (typeof this.volumeInner !== 'undefined') {
            this.kernel.volume = this.volumeInner;
        }
        if (typeof this.playbackRateInner !== 'undefined') {
            this.kernel.playbackRate = this.playbackRateInner;
        }
        this.setKernelEvts(true);
    };
    /**
     * 创建video标签，video标签需要提前在播放内核创建之前初始化。因为load或者play接口才会创建播放内核。但是触发自动播放等行为可能先于load或者
     * play接口，而这些行为依赖video标签的实例。这里创建的video标签在各种播放内核切换中，会做到复用。
     */
    KernelProxy.prototype.createVideoElements = function () {
        var _a = this.playerConfig, instanceId = _a.instanceId, videoElementConfig = _a.videoElementConfig, maxVideoNodeCount = _a.maxVideoNodeCount;
        var createVideoDomOptions = convertVideoElementConfig(__assign(__assign({ preload: this.playerConfig.preloadType === PRELOAD_TYPE.META_DATA ? 'metadata' : 'auto' }, videoElementConfig), { playerid: instanceId }));
        for (var i = 0; i < maxVideoNodeCount; i++) {
            var videoElement = domTool.createVideoDom(createVideoDomOptions);
            this.videoElementsInner.push(videoElement);
        }
        return this.videoElementsInner;
    };
    /**
     * 从初始化播放器的配置中获取播放器的容器元素实例，并设置到 this.container 中
     * 创建时，检测 container 是否存在有其他实例，如果有，则抛出异常
     */
    KernelProxy.prototype.setPlayerContainer = function () {
        var _a = this.playerConfig, container = _a.container, instanceId = _a.instanceId;
        var containerEl = domTool.getElementFromConfig(container);
        // 检查下能不能找到这个元素
        if (!containerEl) {
            throw new Error("Container ".concat(container, " is not found."));
        }
        // 检测是否有其他实例正在使用这个容器
        if (containerEl.dataset[CONTAINER_DATASET_KEY]) {
            // 有，抛出异常，终止此次初始化
            var msg = "Container ".concat(container, " is used by another player instance. Canceling initialization...");
            this.logger.error("@setPlayerContainer(): ".concat(msg));
            throw new Error(msg);
        }
        // 设置标记，用于防止多次初始化
        containerEl.dataset[CONTAINER_DATASET_KEY] = instanceId;
        this.containerEl = containerEl;
    };
    /**
     * 回滚所有对 Container 的操作，移除事件监听器，清理 Container 容器
     */
    KernelProxy.prototype.unsetPlayerContainer = function () {
        delete this.container.dataset[CONTAINER_DATASET_KEY];
        // ergou 遗留代码，本意是用于移除 container 上的所有事件监听器，但存在副作用以及其他问题（整合 Vue / React 时）
        // 这里最好的办法还是包装 container 上的 addEventListener 方法，记录下所有监听器的 callback，然后在这里 remove 掉
        // 这里先判断下，这个 DOM 在不在文档中，如果不在什么也不用做
        if (this.container.isConnected) {
            var newEmptyDom = this.container.cloneNode();
            this.container.parentNode.replaceChild(newEmptyDom, this.container);
            this.containerEl = newEmptyDom;
        }
        // 清理容器
        this.containerEl.innerHTML = '';
    };
    /**
     * 创建包裹video标签的容器。
     */
    KernelProxy.prototype.createVideoElementsContainer = function () {
        var container = this.container;
        this.videoElementsContainer = domTool.createDom("\n      <div class=\"".concat(VIDEO_CONTAINER_CLASS, "\" style=\"position:absolute;left:0;top:0;width:100%;height:100%;z-index:0;\">\n      </div>\n    ").trim());
        domTool.append(container, this.videoElementsContainer);
    };
    /**
     * 代理kernel的事件，监听以后进行转发。（调用KernelProxy的once方法也完全没问题）
     */
    KernelProxy.prototype.setKernelEvts = function (value) {
        var _this = this;
        if (!this.kernel) {
            return;
        }
        if (value) {
            // 保证kernel对任何事件只监听一次
            this.setKernelEvts(false);
        }
        var func = value ? this.kernel.on : this.kernel.off;
        this.addedEvts.forEach(function (evtName) {
            func.apply(_this.kernel, [evtName, _this.kernelEvtFuncs]);
        });
    };
    KernelProxy.prototype.kernelEvtHandler = function (e) {
        if (this.setLevelWhenKernelSwitchedDefer) {
            // 如果是新内核播放实现切换清晰度的情况下，切换中所有事件都不发出去，等切换成功
            var isSetLevelOver = this.checkSetLevelOverWhenKernelSwitched(e);
            if (isSetLevelOver) {
                this.setLevelWhenKernelSwitchedDefer = null;
            }
        }
        else {
            var isIgnoreEvent = this.handlerInnerEvts(e);
            if (!isIgnoreEvent) {
                this.emit(e.type, e.data);
            }
        }
    };
    /**
     * 需要换内核场景下的切清晰度。此情况下使用新内核直接播放视频，而不是在老的内核上执行setLevel逻辑，因为老的内核已经被销毁。
     */
    KernelProxy.prototype.setLevelWhenKernelSwitched = function (urlConfig, preVideoInfo) {
        this.emit(PLAY_EVENT.SETLEVEL_START, { videoInfo: preVideoInfo, mode: SET_LEVEL_MODE.HARD });
        this.kernel.play(urlConfig, { startTime: (preVideoInfo === null || preVideoInfo === void 0 ? void 0 : preVideoInfo.playtime) || 0 });
        this.setLevelWhenKernelSwitchedDefer = new SimpleDefer();
        return this.setLevelWhenKernelSwitchedDefer.promise;
    };
    /**
     * 检查换内核方式下切换清晰度是否完成。
     * @returns 是否切换完成（无论成功还是失败）
     */
    KernelProxy.prototype.checkSetLevelOverWhenKernelSwitched = function (e) {
        var _a;
        if (e.type === PLAY_EVENT.STATE_CHANGE && e.data.new === VIDEO_STATE.PLAYING) {
            // 播放成功，代表切换成功
            this.setLevelWhenKernelSwitchedDefer.resolve();
            this.emit(PLAY_EVENT.SETLEVEL_OVER, { videoInfo: this.currentVideoInfo });
            return true;
        }
        if (e.type === PLAY_EVENT.ERROR) {
            // 播放出错，代表切换失败
            this.setLevelWhenKernelSwitchedDefer.reject((_a = e.data.videoInfo) === null || _a === void 0 ? void 0 : _a.error);
            this.emit(PLAY_EVENT.SETLEVEL_OVER, { videoInfo: this.currentVideoInfo, fail: true });
            return true;
        }
        return false;
    };
    /**
     * 代理事件
     * @param type 事件类型
     * @param isOnce 是否只执行一次
     */
    KernelProxy.prototype.proxyEvent = function (type, isOnce) {
        if (isOnce === void 0) { isOnce = false; }
        // 1. 只要外部添加监听某个事件：
        // 首先会缓存事件名到数组中，其次当前播放内核就会添加该事件名的监听并在事件监听器中进行转发。转发者为kernel-proxy。
        // 2. 外部移除某个事件的监听：
        // 移除的是kernel-proxy上的监听，而不是kernel上的。kernel上的监听只在kernel被销毁的时候移除。
        if (this.addedEvts.includes(type))
            return;
        this.addedEvts.push(type);
        if (!this.kernel)
            return;
        if (isOnce) {
            this.kernel.once(type, this.kernelEvtFuncs);
            return;
        }
        this.kernel.on(type, this.kernelEvtFuncs);
    };
    /**
     * 执行urlConfig播放前的内核检查，如果更换了格式，需要切换内核否则抛错
     */
    KernelProxy.prototype.checkConfigBeforeLoad = function (urlConfig, extra) {
        return __awaiter(this, void 0, void 0, function () {
            var error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!urlConfig) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.checkWhetherNeedToSwitchKernel(urlConfig, extra)];
                    case 1:
                        error = (_a.sent()).error;
                        if (error) {
                            this.emit(PLAY_EVENT.ERROR, { videoInfo: { error: error } });
                            throw error;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
    * 销毁当前内核
    */
    KernelProxy.prototype.destroyKernel = function () {
        if (this.kernel) {
            this.emit(PLAY_EVENT.KERNEL_DESTROY, { kernelName: this.kernel.kernelName });
            this.setKernelEvts(false);
            this.kernel.destroy();
            this.kernel = null;
        }
    };
    /**
     * 内部处理内核事件
     * @returns isIgnoreEvent 是否忽略事件，不对外转发
     */
    KernelProxy.prototype.handlerInnerEvts = function (e) {
        if (e.type === PLAY_EVENT.ERROR && this.kernel.kernelName === KERNEL_NAME.DEMUX_2_FMP4) {
            // 注意：这个demux2fmp4内核的回滚逻辑只能单个video播放有效，列表播放会有问题
            var videoInfo = e.data.videoInfo;
            var autoFallbackKernel = videoInfo.config.autoFallbackKernel;
            if (!!autoFallbackKernel) {
                this.logger.error("play err with ".concat(KERNEL_NAME.DEMUX_2_FMP4, ", fallback to ").concat(KERNEL_NAME.ORIGIN));
                // demux2fmp4和origin内核功能相等，如果demux2fmp4内核失败，回退到origin内核再播放一次
                this.play(videoInfo.config, { startTime: videoInfo.playtime, kernelName: KERNEL_NAME.ORIGIN });
                return true;
            }
        }
        return false;
    };
    __decorate([
        performanceCost,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", Promise)
    ], KernelProxy.prototype, "play", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", Promise)
    ], KernelProxy.prototype, "load", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], KernelProxy.prototype, "setAudioTrack", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Array, Object]),
        __metadata("design:returntype", Promise)
    ], KernelProxy.prototype, "setLevel", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], KernelProxy.prototype, "destroy", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], KernelProxy.prototype, "createKernel", null);
    return KernelProxy;
}(EvtEmitter));
export default KernelProxy;
